import { render, staticRenderFns } from "./Ocean Fishing Raft.vue?vue&type=template&id=6b82b774&"
import script from "./Ocean Fishing Raft.vue?vue&type=script&lang=js&"
export * from "./Ocean Fishing Raft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports